import {definePreset} from "@primeng/themes";
import Aura from "@primeng/themes/aura";
import {colors} from "../../tailwind.config";

export const MyPreset = definePreset(Aura, {
  primitive: {
    gradientBlue: {
      400: '#30A2FF',
      500: '#1488FC',
    },
    ...colors,
  },
  semantic: {
    text: {
      // color: "blue"
    },
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    colorScheme: {
      light: {
        link: {
          color: '{blue.500}',
        },
        surface: {
          0: '#ffffff',
          50: '{zinc.50}',
          100: '#FAF6F5',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '#434240',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}'
        },
      },
    }
  },
  components: {
    divider: {
      content: {
        background: '{surface.100}',
      }
    },
    dialog: {
      header: {
        padding: '{overlay.modal.padding} {overlay.modal.padding} 0.5rem {overlay.modal.padding}'
      }
    },
    accordion: {
      header: {
        color: '{text.color}',
        padding: '1.5rem 1.5rem 1.5rem 0',
      },
      content: {
        background: 'transparent',
        color: '{text.color}',
        padding: '0 0 1rem 0',
      }
    },
    button: {
      paddingX: '1.5rem',
      paddingY: '0.75rem',
      label: {
        fontWeight: 'bold'
      },
      sm: {
        paddingX: '1rem',
        paddingY: '0.30rem'
      },
      colorScheme: {
        outlined: {
          secondary: {
            background: '{surface.100}',
            color: '{surface.950}',
            borderColor: '{surface.950}',
          },
        },
        text: {
          info: {
            color: "{orange.500}"
          }
        },
        primary: {
            // background: '{surface.400}',
          disabled: {
          }
        },
        secondary: {
          background: "{surface.950}",
          color: "{surface.0}",
        },
        info: {
          background: "{orange.500}",
          color: "{surface.0}",
          border: {
            color: "{orange.500}"
          },
          hover: {
            background: "{orange.600}",
            color: "{surface.0}",
            border: {
              color: "{orange.600}"
            }
          }
        },
        contrast: {
            background: "{surface.0}",
            color: "{surface.950}",
        }
      },
      borderRadius: '2rem',
    },
    tabs: {
      tab: {
        activeColor: 'orange',
        // color: 'orange',
      },
      tablist: {
        colorScheme: {
          light: {
            //background: 'red',
          }
        }
      },
      activeBar: {
        height: 0,
      }
    },
    card: {
      shadow: '1px 1px 1px rgba(0,0,0,0.2)',
      background: '{surface.100}',
    },
    togglebutton: {
      padding: '0.8rem 2rem',
      colorScheme: {
        border: {
          color: '{surface.200}',
        },
        background: 'white',
        light: {
          checkedBackground: 'white',
          checked: {
            color: 'white',
          },
          font: {
            weight: '400'
          },
          checkedBorderColor: '{surface.200}',
          content: {
            checked: {
              background: '{surface.700}',
            }
          }
        }
      }
    },
    galleria: {
      closeButton: {
        background: 'rgba(0, 0, 0, 0.6)',
      }
    },
    rating: {
      icon: {
        color: '{surface.400}',
        activeColor: '{orange.400}',
        hoverColor: '{orange.300}',
        size: '1.75rem',
      }
    },
    drawer: {
      content: {
        padding: '1.75rem 1.25rem 2rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        overflow: 'auto',
        height: '100%'
      },
      closeButton: {
        top: '1rem',
        right: '1rem'
      }
    }
  }},
  {
    darkModeSelector: '.aa'
  }
)

export const orangePanel = definePreset(MyPreset, {
  root: {
    background: '{orange.500}',
    borderColor: 'transparant'
  },
  header: {
    borderWidth: '0',
  }
})

export const lighterOrangePanel = definePreset(MyPreset, {
  root: {
    background: '{orange.400}',
    borderColor: 'transparant'
  },
  header: {
    borderWidth: '0',
  }
})

export const outlinedPanelButton = definePreset(MyPreset, {
  root: {
    outlined: {
      secondary: {
        background: '{surface.100}',
        border: {
          color: '{orange.400}'
        },
        borderColor: '{orange.400}',
      },
    },
    secondary: {
      background: '{surface.100}',
      border: {
        color: '{orange.400}'
      },
      borderColor: '{orange.400}',
    },
  },
})


export const whiteDividerDt = {
  root: {
    content: {
      background: "white",
    }
  },
}

export const whiteButtonDt = definePreset(MyPreset, {
  root: {
    primary: {
      background: '{surface.200}',
      color: '{surface.900}',
      border: {
        color: '{surface.300}'
      },
      hover: {
        background: '{surface.300}',
        color: '{surface.950}',
        border: {
          color: '{surface.300}'
        }
      }
    }
  }
})
